import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CampaignsAPI from '../../api/campaigns';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { CAMPAIGNS_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: {
    data: [],
    meta: {},
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCampaigns: _state => campaignType => {
    const data = (_state.records?.data || []).filter(
      record => record.campaign_type === campaignType
    );
    const meta = _state.records?.meta || {};
    return { data, meta };
  },
  getAllCampaigns: _state => {
    return _state.records?.data || [];
  },
};

export const actions = {
  get: async function getCampaigns({ commit },  page = 1) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const response = await CampaignsAPI.get(page);
      commit(types.SET_CAMPAIGNS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createCampaign({ commit }, campaignObj) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: true });
    try {
      const response = await CampaignsAPI.create(campaignObj);
      commit(types.ADD_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isUpdating: true });
    try {
      const response = await CampaignsAPI.update(id, updateObj);
      AnalyticsHelper.track(CAMPAIGNS_EVENTS.UPDATE_CAMPAIGN);
      commit(types.EDIT_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isDeleting: true });
    try {
      await CampaignsAPI.delete(id);
      AnalyticsHelper.track(CAMPAIGNS_EVENTS.DELETE_CAMPAIGN);
      commit(types.DELETE_CAMPAIGN, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isDeleting: false });
    }
  },
  report: async ({ commit }, id) => {
    try {
      await CampaignsAPI.report(id);
      commit(types.REPORT_CAMPAIGN, id);
    } catch (error) {
      this.$toast.error('Erro ao baixar o relatório, tente novamente.');
      throw new Error(error);
    }
  },
  pause: async ({ commit }, id) => {
    try {
      const response = await CampaignsAPI.pause(id);
      commit(types.UPDATE_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  resume: async ({ commit }, id) => {
    try {
      const response = await CampaignsAPI.resume(id);
      commit(types.UPDATE_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  cancel: async ({ commit }, id) => {
    try {
      const response = await CampaignsAPI.cancel(id);
      commit(types.UPDATE_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.SET_CAMPAIGN_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_CAMPAIGN]: MutationHelpers.create,
  [types.SET_CAMPAIGNS]: MutationHelpers.set,
  [types.EDIT_CAMPAIGN]: MutationHelpers.update,
  // Campaigns are paginated ({ data, meta }), so this mutation updates the
  // record inside `data` instead of relying on MutationHelpers.update.
  [types.UPDATE_CAMPAIGN]: (_state, data) => {
    const records = _state.records?.data || [];
    _state.records = {
      ..._state.records,
      data: records.map(record =>
        record.id === data.id ? { ...record, ...data } : record
      ),
    };
  },
  [types.DELETE_CAMPAIGN]: MutationHelpers.destroy,
  [types.REPORT_CAMPAIGN]: MutationHelpers.report,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
